
import { Options, Vue } from 'vue-class-component'
import { uploadBytes, getDownloadURL, ref } from "firebase/storage";
import { useFirebaseStorage } from 'vuefire'

@Options({})
export default class Top extends Vue {
  key = 'dummy'
  fileUrl = ''
  fileDataUrl = ''

  // Firebase Storage
  private storage = useFirebaseStorage()

  // ファイルアップロード
  // https://stackoverflow.com/questions/69963419/firebase-storage-ref-is-not-a-function
  uploadFile() {
    const files = (this.$refs.file as HTMLInputElement).files
    if (!files) return
    const file = files[0]
    // const ext = file.name.split('.').pop()
    const fileRef = ref(this.storage, `${this.key}/src`)
    const uploadTask = uploadBytes(fileRef, file)
    uploadTask.then((snapshot) => {
      getDownloadURL(snapshot.ref)
        .then((url) => {
          // Cross-Origin-Resource-Policy
          this.fileUrl = url
          fetch(url)
            .then( response => response.blob() )
            .then( blob =>{
                var reader = new FileReader()
                reader.onload = () => { 
                  this.fileDataUrl = reader.result as string
                }
                reader.readAsDataURL(blob)
            });
          
        })
    })
  }
}
